module.exports = __webpack_public_path__ + "static/media/operators.d29abc1f.svg";